import { canPermission, normalizePermissions } from './adminPermissions'
import { getAdminSessionAdmin } from './adminSession'

export function getCurrentAdminAccount() {
  return getAdminSessionAdmin() || { id: null, email: '', name: '관리자', role: 'NONE' }
}

export function getCurrentAdminPermissions() {
  const current = getCurrentAdminAccount()
  return normalizePermissions(current.role || 'NONE', current.permissions)
}

export function currentAdminCan(route, action = 'view') {
  return canPermission(getCurrentAdminPermissions(), route, action)
}
